import { styled } from '@mui/material/styles';
import ScrollArea from 'app/components/ScrollArea';

const MenuWrapperScrollArea = styled(ScrollArea)(({ theme }) => ({
  borderRadius: theme.borderRadius.small,
}));

export default MenuWrapperScrollArea;
